import { NgModule } from '@angular/core';
import { COMMON_MODULES } from '../../constants/common-modules';
import { AllowanceFormComponent } from './allowance-form.component';

@NgModule({
  declarations: [AllowanceFormComponent],
  imports: [...COMMON_MODULES],
  exports: [AllowanceFormComponent],
})
export class AllowanceFormModule {}
